class AbstractResource {
  resourceName = ''

  constructor(client) {
    this.client = client
  }

  all = async (params = {}) => {
    const response = await fetch(
      `${this.client.getBaseFetchUrl()}/${this.resourceName}`
    )
    return await response.json()
  }

  getById = async id => {
    const response = await fetch(
      `${this.client.getBaseFetchUrl()}/${this.resourceName}/${id}`
    )
    return await response.json()
  }

  sendForm = async (datas, wpformsID, pageID) => {
    const response = await fetch(
      `${this.client.getBaseFetchUrl()}/${this.resourceName}/add_entry/?id=${wpformsID}&page_id=${pageID + datas}`,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      }
    )
    return await response.json()
  }
}

export default AbstractResource


// WEBPACK FOOTER //
// ./src/services/wpapi/ressources/abstract.js